import { IsNotEmpty, IsString } from 'class-validator';
import { MapaCriarDto } from '../mapa';

export class NucleoCriarDto extends MapaCriarDto {
  @IsString()
  @IsNotEmpty()
  nome: string;
}
